
    import { Mapper } from "../../../../base/utils/mapper";
import { CompositionNeuropsychologyResponseModel } from "../../../../domain/models/consult/composition-neuropsychology-response.model";
import { CompositionNeuropsychologyResponseEntity } from "../entities/composition-neuropsychology-response.entity";
    export class CompositionImplementationNeuropsychologyRepositoryMapper extends Mapper<CompositionNeuropsychologyResponseEntity, CompositionNeuropsychologyResponseModel>{
        mapFrom(param:  CompositionNeuropsychologyResponseEntity):  CompositionNeuropsychologyResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  CompositionNeuropsychologyResponseModel):  CompositionNeuropsychologyResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }